module.exports = __webpack_public_path__ + "img/quan.038d2021.png";